// src/data/ArticlesData.js

export const Articles = [
  {
    id: 1,
    title: 'Putting AI to work: better, faster, more accurate analysis of plastic samples',
    imageSrc: 'https://via.placeholder.com/800x500?text=AI+Plastic+Analysis',
    imageSrcAlt: 'AI analyzing plastic samples',
    excerpt: 'Our latest AI models are revolutionising how researchers and companies identify and categorise different plastic types with unprecedented accuracy.',
    content: 'Our latest AI models are revolutionising how researchers and companies identify and categorise different plastic types with unprecedented accuracy. By leveraging advanced machine learning algorithms and our extensive spectral database, we can now identify microplastics and complex polymer blends with 98.5% accuracy in a fraction of the time previously required.',
    // Note: Using future dates based on original example. Adjust if needed.
    date: 'April 2, 2025', // This date is in the future as of 2024-05-15
    author: 'Dr. Joseph Levermore',
    time: '5 min read', // This field was removed in the minimal card, but kept in data
    category: 'Technology',
    articlepagehref: 'ai-plastic-analysis' // Used for navigation URL slug
  },
  {
    id: 2,
    title: 'The real world of AI in science and environmental monitoring',
    imageSrc: 'https://via.placeholder.com/800x500?text=Environmental+Monitoring',
    imageSrcAlt: 'Environmental monitoring using AI',
    excerpt: 'How our spectral analysis technology is being deployed in field research to monitor plastic pollution in oceans and waterways.',
    content: 'How our spectral analysis technology is being deployed in field research to monitor plastic pollution in oceans and waterways. Research teams across five continents are now using Plastic Analytics technology to conduct real-time analysis of water samples, helping create the most comprehensive map of plastic pollution ever developed.',
    date: 'March 24, 2025', // Future date
    author: 'Dr. Joseph Levermore',
    time: '4 min read',
    category: 'Research',
    articlepagehref: 'environmental-monitoring'
  },
  {
    id: 3,
    title: 'Multimodality powered by AI: combining FTIR and Raman spectroscopy',
    imageSrc: 'https://via.placeholder.com/800x500?text=Multimodal+Analysis',
    imageSrcAlt: 'Multimodal spectral analysis',
    excerpt: 'Our breakthrough in multimodal analysis allows researchers to leverage both FTIR and Raman spectroscopy in a single platform.',
    content: 'Our breakthrough in multimodal analysis allows researchers to leverage both FTIR and Raman spectroscopy in a single platform. This integration provides complementary data that significantly improves identification accuracy and reduces false positives, especially when dealing with complex polymer blends or weathered samples.',
    date: 'March 15, 2025', // Future date
    author: 'Dr. Joseph Levermore',
    time: '6 min read',
    category: 'Technology',
    articlepagehref: 'multimodal-analysis'
  },
  {
    id: 4,
    title: `Machine learning advances: how we're improving detection accuracy`,
    imageSrc: 'https://via.placeholder.com/800x500?text=Machine+Learning+Advances',
    imageSrcAlt: 'Machine learning model visualisation',
    excerpt: 'Behind the scenes of our latest algorithm improvements that have pushed detection accuracy to new heights.',
    content: 'Behind the scenes of our latest algorithm improvements that have pushed detection accuracy to new heights. Our research team explains the novel approaches to feature extraction and classification that have resulted in a 15% improvement in identifying weathered and degraded plastic samples.',
    date: 'February 28, 2025', // Future date
    author: 'Dr. Joseph Levermore',
    // time: - Missing in original data for this item
    category: 'Technology',
    articlepagehref: 'ml-advances'
  },
];